import React, { useCallback, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import {
  isMobile,
  betStore,
  freeBetStore,
  userInfoStore,
  useTranslation,
  notificationStore,
  useInputValueChangingFunctions,
} from '@pascal/pascal-core';
import { applicationStore, gameConfigStore } from '@pascal/pascal-core/shared/core/store';
import { InputTypesForChanging } from '@pascal/pascal-core/shared/core/enums/additionalInputValueChangingButtons';

import { doBetStore, gameStore } from '../../../store';
import { betTypesStore } from '../../../store/betTypesStore';
import { wageringStore } from '../../../store/wageringStore';
import { betAmountValidator } from '../../../helpers/supporters';

export const BetBlockWrapper = observer(({ innerComp: InnerComp }) => {
  const t = useTranslation();
  const { liveBets } = betStore;
  const { doBetSender, reBetData } = doBetStore;
  const { limits } = gameConfigStore;
  const { isDemo } = applicationStore;
  const { currencyCode } = userInfoStore;
  const { activeFreeBet } = freeBetStore;
  const { partnerWageringOdd } = wageringStore;
  const { betTypes, selectedType, setSelectedType, betTypesActiveBets } = betTypesStore;

  const {
    isBetsClosed,
    numPadData: { isOpen },
    setNumPadData,
  } = gameStore;

  const {
    setBetAmount,
    totalBetsAmount,
    isLoadingBetButton,
    isLoadingReBetButton,
    betData: { amount },
  } = doBetStore;

  const [numPudInputValue, updateNumPudInputValue] = useState(limits.minBet);

  const { handleChangeInputValue } = useInputValueChangingFunctions({
    changingValue: amount,
    changingValueCallback: setBetAmount,
    additionalInputInfo: { inputType: InputTypesForChanging.BetInput },
  });

  const handleInputBlur = (betAmount) => betAmountValidator(betAmount, gameConfigStore.limits);

  useEffect(() => {
    if (betTypes[0] && !selectedType) {
      setSelectedType({ odd: betTypes[0].odd, color: betTypes[0].color });
    }
  }, [betTypes, selectedType]);

  const validatedNumPudInputValue = (callback) => {
    const { validatedBetAmount, errorMessageCode } = handleInputBlur(numPudInputValue);
    if (errorMessageCode) {
      notificationStore.setNotificationType({ responseCode: errorMessageCode });
    }
    callback(validatedBetAmount);
  };

  const handleSubmit = useCallback(
    (isConfirmed) => {
      if (isConfirmed) {
        validatedNumPudInputValue(doBetStore.setBetAmount);
        gameStore.setNumPadData({ isOpen: false, sectionName: null, currentInputValue: null });
      }
    },
    [numPudInputValue]
  );

  const handleOpenNumPad = (event) => {
    if (isMobile()) {
      updateNumPudInputValue(event.target.value);
      gameStore.setNumPadData({
        isOpen: true,
        currentInputValue: event.target.value,
      });
    }
  };

  const handleChangeBetType = useCallback((oddType, color) => {
    setSelectedType({ odd: oddType, color });
  }, []);

  const handleClickBet = () => {
    // const { id: freeBetId, amount: freeBetAmount } = activeFreeBet;
    // const betDataModel = {
    //   betData: selectedType.color,
    //   amount,
    //   roundId,
    // };
    // if (freeBetId && !isDemo) {
    //   betDataModel.freeBetId = freeBetId;
    //   betDataModel.amount = freeBetAmount;
    // }
    doBetSender(selectedType.color);
  };

  return (
    <InnerComp
      t={t}
      isOpen={isOpen}
      bets={liveBets}
      isDemo={isDemo}
      limits={limits}
      betAmount={amount}
      betTypes={betTypes}
      reBetData={reBetData}
      isMobile={isMobile()}
      odd={selectedType?.odd}
      handleSubmit={handleSubmit}
      activeButton={isBetsClosed}
      setBetAmount={setBetAmount}
      currencyCode={currencyCode}
      activeFreeBet={activeFreeBet}
      setNumPadData={setNumPadData}
      handleClickBet={handleClickBet}
      handleInputBlur={handleInputBlur}
      totalBetsAmount={totalBetsAmount}
      handleOpenNumPad={handleOpenNumPad}
      numPudInputValue={numPudInputValue}
      betPendingToggle={isLoadingBetButton}
      reBetPendingToggle={isLoadingReBetButton}
      betTypesActiveBets={betTypesActiveBets}
      partnerWageringOdd={partnerWageringOdd}
      handleChangeBetType={handleChangeBetType}
      updateNumPudInputValue={updateNumPudInputValue}
      handleChangeInputValue={handleChangeInputValue}
    />
  );
});
